//@flow

import { roundOff } from '../../lib/utils';

const getAverage = (ratings: Object) => {
  if (!ratings) return;

  const ratingsCameForSelfGuidedTrek = Object.keys(ratings).length === 1;
  if (ratingsCameForSelfGuidedTrek) {
    // return the first value of the key in the object
    return roundOff(Number(Object.values(ratings)[0]) / 2, 2);
  }

  let totalStars = 0;
  const numberOfStars = 10;

  for (let key in ratings) {
    totalStars += Number(ratings[key]);
  }

  return roundOff(totalStars / numberOfStars, 2);
};

export default getAverage;



// WEBPACK FOOTER //
// ./src/components/ReviewsRatings/utils.js